module.exports = __webpack_public_path__ + "img/bigshama.67d35365.png";